import { createAction } from 'redux-actions';
import { CALL_SERVICE } from '@instructure/redux-service-middleware';
import { SET_ERROR, SET_FEATURES, getFeatureFlags } from "../../constants.js";
export var setError = createAction(SET_ERROR);
export var setFeatures = createAction(SET_FEATURES);
export var loadFeatures = function loadFeatures(host, jwt) {
  return function (dispatch) {
    if (getFeatureFlags().length === 0) {
      return Promise.resolve();
    }
    return dispatch({
      type: CALL_SERVICE,
      payload: {
        service: 'outcomes',
        method: 'getFeatures',
        args: [host, jwt]
      }
    }).then(function (json) {
      return dispatch(setFeatures(json));
    }).catch(function (e) {
      return dispatch(setError(e));
    });
  };
};